import { render, staticRenderFns } from "./SleeveAssignmentsCard.vue?vue&type=template&id=fdd34b3a&scoped=true&"
import script from "./SleeveAssignmentsCard.vue?vue&type=script&lang=js&"
export * from "./SleeveAssignmentsCard.vue?vue&type=script&lang=js&"
import style0 from "./SleeveAssignmentsCard.vue?vue&type=style&index=0&id=fdd34b3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd34b3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VCol,VRow,VSimpleTable})
